import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { ConfirmationConfig } from '../models/confirmation-config.model';
import { AlertComponent } from '../components/popups/alert/alert.component';

@Injectable()
export class AlertService {
  constructor(public dialog: MatDialog) { }

  public show(config: ConfirmationConfig): Observable<boolean> {
    let dialogRef: MatDialogRef<AlertComponent>;
    dialogRef = this.dialog.open(AlertComponent, {
      maxWidth: '450px',
      autoFocus: true
    });

    Object.assign(dialogRef.componentInstance, config);

    return dialogRef.afterClosed();
  }
}
